'use strict';



import Tabs        from './Tabs';
import TabsBar     from './TabsBar';
import TabsItem    from './TabsItem';
import TabsContent from './TabsContent';
import SwitchTabs  from './SwitchTabs';



const TabsItems = {
  name: 'tabs-items',

  render(h) {
    return h('div', { 'class': { 'dn-tabs__items': true }}, [this.$slots.default])
  }
}



export default {
  Tabs,
  TabsBar,
  TabsItem,
  TabsItems,
  TabsContent,
  SwitchTabs,
}



// WEBPACK FOOTER //
// ./src/js/ui/components/tabs/index.js